import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fsFileSize'
})
export class FsFileSizePipe implements PipeTransform {
  public KB = 1024;
  public MB = 1048576;
  public GB = 1073741824;

  transform(value: number, fileType: string = 'f'): string {
    // return value
    if (fileType === 'b') {
      return '';
    }
    if (fileType === 'd' || fileType === 's') {
      return value ? value + ' items' : 'Empty';
    }

    if (value < this.KB) {
      return value + ' bytes'
    }
    if (value < this.MB) {
      return Math.round(value / this.KB * 10) / 10 + ' KB'
    }
    if (value < this.GB) {
      return Math.round(value / this.MB * 10) / 10 + ' MB'
    }
    return Math.round(value / this.GB * 10) / 10 + ' GB'
  }

}
